module.exports = __webpack_public_path__ + "img/pic-1-4.08257f5b.jpg";